export default __webpack_public_path__ + "static/media/good@3x.1582af3b.png";